module.exports = __webpack_public_path__ + "img/genesightlogo-transparent.e445dca2.png";